export default {
  "cmps-right-nav": () => import("/src/layouts/cmps/RightNav.vue").then(m => m.default || m),
  constants: () => import("/src/layouts/constants.ts").then(m => m.default || m),
  default: () => import("/src/layouts/default.vue").then(m => m.default || m),
  types: () => import("/src/layouts/types.ts").then(m => m.default || m)
}